<template>
    <Card>
        <p slot="title">
            <!-- <Icon type="md-alert" /> -->
            仓库商品拆分比例日志列表
        </p>
        <template slot="extra">
            <router-link to="/splitList">返回</router-link>
        </template>
        <Row>
            <Col span="24">
                <Table
                    :style="{marginTop:'10px'}"
                    border
                    stripe
                    :loading="loading"
                    :columns="columns"
                    :data="tbList">
                    <template slot-scope="{ row,index }" slot="sort">
                        <span v-show="false">{{row.code}}</span>
                        {{index+1}}
                    </template>
                </Table>
            </Col>
        </Row>
    </Card>
</template>
<script>
const columns = [
  {
    title: '序号',
    slot: 'sort',
    width: 60
  },
  {
    title: '类型',
    key: 'name'
  },
  {
    title: '操作内容',
    key: 'name'
  },
  {
    title: '模块',
    key: 'name'
  },
  {
    title: '控制器',
    key: 'name'
  },
  {
    title: '方法名',
    key: 'name'
  },
  {
    title: '操作人',
    key: 'name'
  },
  {
    title: '创建时间',
    key: 'name'
  },
]
    export default {
        data () {
            return {
                columns,
                tbList:[],
                loading:false,
            }
        },
        created(){
            this.getList();
        },
        methods: {
            getList(){
                
                      this.$Message.success('暂无接口');
                // this.loading = true;
                // this.$api.splitSearch({}).then(res=>{
                //     this.loading = false;
                //     if(res.code=='200'){
                //         this.tbList = res.data;
                //     }
                // })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/warehouse/splitDetail.vue